import React from "react";
import { styled } from "@mui/system";
import MUIListItem from "@mui/material/ListItem";
import { ListItemProps as ListItemPropsMUI } from "@mui/material/ListItem";
export interface ListItemProps extends ListItemPropsMUI {
  component?: React.ElementType;
}

const ListItemRoot = styled(MUIListItem, {
  name: "ListItem",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) =>
  theme.name === "fic"
    ? {
        "&.MuiListItem-root": {
          paddingTop: 10,
          paddingBottom: 10,
          "&:hover": {
            background: theme.palette.primary.surfaceHover
          },
          "&.MuiButtonBase-root.MuiListItemButton-root.ListItemButton-root.Mui-selected":
            {
              background: theme.palette.primary.interactiveSelected
            }
        },
        "&.MuiListItem-root.MuiListItem-dense": {
          paddingTop: 4,
          paddingBottom: 4
        }
      }
    : {
        "&.MuiListItem-root": {
          paddingTop: 10,
          paddingBottom: 10,
          border: "1px solid transparent",
          "&:hover": {
            border: "1px solid " + theme.palette.primary.interactiveDefault,
            background: theme.palette.primary.surfaceDefault
          }
        },
        "&.MuiListItem-root.MuiListItem-dense": {
          paddingTop: 4,
          paddingBottom: 4
        }
      }
);

export const ListItem = React.forwardRef<HTMLLIElement, ListItemProps>(
  function ListItem(props, ref) {
    return <ListItemRoot {...props} ref={ref} />;
  }
) as React.FC<ListItemProps>;
